import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=7977534e&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=7977534e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977534e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kusanagi/adop-line-ec_plaisir/b2b/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7977534e')) {
      api.createRecord('7977534e', component.options)
    } else {
      api.reload('7977534e', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=7977534e&scoped=true&", function () {
      api.rerender('7977534e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Category.vue"
export default component.exports